<template>
<div>
    <div id="mygalModal" aria-hidden="true" class="modal fade move-up in intro-modal modal-for-gal" style="display: block;">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="new-modal">
                    <div class="modal_down bacground_sdo">
                        <div class="intro-modal-body">
                            <div class="intro-modal-heading"><strong>Process Payment</strong></div>
                            <div class="trial-details">
                                <div class="preview" style="padding-top: 35px !important;">
                                    <div id="card-element" ref="card" class="my-input"></div>
                                </div>
                                <google-places-autocomplete :api-key="googleMapsApiKey" @address-updated="getAddressDataBilling" />
                                <div class="footer-button" style="padding-top: 35px !important;">
                                    <div class="div-block-1120">
                                        <a href="#" @click="processPayment($event)" class="button-44 w-button dash-button">
                                            <span v-if="submitted"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; display: block; shape-rendering: auto;" width="15px" height="15px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                                                    <circle cx="50" cy="50" fill="none" stroke="blue" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
                                                        <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.53475935828877s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
                                                    </circle>
                                                </svg></span>
                                            <span style="color:#fff" v-else>Pay  ${{ subscription.amount }} Now</span></a>
                                        <a href="#" @click="CloseDialog($event)" class="button-45 w-button dash-button">Cancel</a>
                                    </div>
                                </div>
                                <div class="w-form-fail" style="display: block;" v-if="errorMessage">
                                    <div>{{ errorMessage }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    BasisTheory
} from "@basis-theory/basis-theory-js";
const bt = await new BasisTheory().init(process.env.VUE_APP_BASIS, {
    elements: true
});
import GooglePlacesAutocomplete from '../common/GooglePlacesAutocomplete.vue'
export default {
    props: ["baseUrl", "subscription"],
    components: {
        GooglePlacesAutocomplete,
    },
    data() {
        return {
            mykey: 1,
            token: null,
            errorReason: '',
            errorMessage:'',
            submitted: false,
            googleMapsApiKey: process.env.VUE_APP_GOOGLE_KEY,
            billingAddress: {
                addressLine1: '',
                addressLine2: '',
                city: '',
                state: '',
                zip: ''
            },
        }
    },
    mounted() {
        this.createCardElement();
    },
    methods: {
        getAddressDataBilling(address){
            this.billingAddress.addressLine1 = address.street;
            this.billingAddress.addressLine2 = address.address_line2;
            this.billingAddress.city = address.city;
            this.billingAddress.state = address.state;
            this.billingAddress.zip = address.zip;
            console.log(this.billingAddress)
        },
        validateAddress(address) {
        return address.addressLine1 && 
                address.city && 
                address.state && 
                address.zip;
        },
        processPayment(event) {
            this.errorReason = false;
            if (!this.validateAddress(this.billingAddress)) {
                this.errorReason = true;
                this.errorMessage = "Please enter a complete billing address.";
                this.submitted = false;
                return false;
            }

            event.preventDefault();
            this.errorReason = false;
            this.submitted = true;
            bt.tokens
                .create({
                    type: "card",
                    data: this.cardElement,
                })
                .then((token) => {
                    this.token = token;
                    this.submitPayment();
                })
                .catch((error) => {
                    console.log(error);
                    this.errorMessage = "Invalid card details";
                    this.errorReason = true;
                    this.submitted = false;
                });
        },
        createCardElement() {
            this.cardElement = bt.createElement('card');
            this.cardElement.mount('#card-element');
        },
        CloseDialog(event) {
            event.preventDefault();
            this.$emit("CloseBox");
        },
        submitPayment() {
            this.errorMessage = null;
            this.$axios.post(this.baseUrl + '/api/process-subs-payment', {
                token: this.token.id,
                details: this.token.data,
                billingAddress: this.billingAddress,
                subscription_id: this.subscription.id,
                amount: this.subscription.amount
            })
            .then(response => {
                console.log(response.data)
                if (response.data.status === 'success') {
                    this.$emit("PaymentSuccess");
                    this.$emit("CloseBox");
                } else if (response.data.status === 'error') {
                    this.errorMessage = response.data.message || "Payment failed";
                    this.submitted = false;
                } else {
                    this.errorMessage = "Payment failed";
                    this.submitted = false;
                }
            })
            .catch(error => {
                let errorMessage = "Payment processing failed";
                
                if (error.response?.data?.status === 'error') {
                    errorMessage = error.response.data.message;
                } else if (error.response?.data?.message) {
                    errorMessage = error.response.data.message;
                } else if (error?.message) {
                    errorMessage = error.message;
                }
                
                this.errorMessage = errorMessage;
                this.$emit("PaymentError", errorMessage);
                this.submitted = false;
                console.log(error);
            });

        }
    },
    created() {
        //this.setUpStripe();
    }
}
</script>

<style scoped>
.modal {
    display: block;
    position: fixed;
    z-index: 1000;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0, 0, 0, 0.5);
}

.intro-modal-body {
    justify-content: center;
}

.intro-modal-heading {
    font-size: 18px;
    display: flex;
    justify-content: center;
}

.modal-content {
    background-color: #fefefe;
    border-radius: 10px;
    max-width: 468px;
    margin: 15% auto;
    padding: 20px;
    border: 1px solid #888;
    width: 80%;
}

.dash-button {
    height: 45px;
}
.my-input {
    padding: 15px;
    border: 1px solid #ccc;
    border-radius: 9px;
    margin-bottom: 15px;
    height: '55px';
}

.payment-info {
    background-color: #f8f9fa;
    padding: 15px;
    border-radius: 8px;
    margin-bottom: 20px;
}

.subscription-details p {
    margin: 5px 0;
    font-size: 14px;
}
</style>